import gql from 'graphql-tag';

export const removeCompanyMutation = gql`
  mutation RemoveCompany($id: ID!) {
    removeCompany(id: $id)
  }
`;